export const APPROACH_THE_ROL = 'Ejercicio de acercamiento al rol';

// ONLY TEST
export const MOCK_ENSAY = 'Ensayo'
export const MOCK_APPROACH_THE_ROL = 'Ejercicio de acercamiento al rol'
export const MOCK_ID_ACTIVITY = '2987234'